import React from 'react';
import sriniImg from '../assets/srini_tagirisa.jpeg';

const ceo = {
  name: 'Srini Tagirisa',
  title: 'Founder & CEO',
  img: sriniImg,
  bio: '25+ years engineering networking and cloud platforms at scale. Technical lead on Cisco\'s ASR9000 and ONS15454 — multi-billion dollar product lines. Built Ericsson\'s next-generation edge router platform. Led WiFi Cloud Engineering at Comcast, serving millions of subscribers. Core architect of the Plume Cloud Platform. VP of Engineering at multiple startups.',
  linkedin: 'https://www.linkedin.com/in/srini-tagirisa-5b87554'
};

const reports = [
  {
    name: 'Shankar Peerthy',
    title: 'Sales',
    placeholder: false
  },
  {
    name: 'Rajesh Benjamin',
    title: 'Business Development',
    placeholder: false
  }
];

const About = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh' }}>
      {/* Page Header */}
      <section style={{ padding: '80px 40px 40px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '16px' }}>Leadership Team</h1>
        <p style={{ color: '#a0aec0', fontSize: '1.15rem', maxWidth: '650px', margin: '0 auto', lineHeight: '1.8' }}>
          Industry veterans with decades of experience building massively scalable
          cloud-native platforms and enterprise networking products used by millions.
        </p>
      </section>

      {/* Org Tree */}
      <section style={{ padding: '20px 40px 60px', maxWidth: '1100px', margin: '0 auto' }}>

        {/* CEO Card - Top of tree */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0' }}>
          <div style={{
            padding: '32px', backgroundColor: '#0a1628', borderRadius: '12px',
            border: '1px solid #1a2744', maxWidth: '520px', width: '100%', textAlign: 'center'
          }}>
            <img src={ceo.img} alt={ceo.name} style={{
              width: '120px', height: '120px', borderRadius: '50%',
              objectFit: 'cover', marginBottom: '20px',
              border: '3px solid #1a2744'
            }} />
            <h3 style={{ fontSize: '1.4rem', marginBottom: '4px' }}>{ceo.name}</h3>
            <p style={{ color: '#60a5fa', fontSize: '1.05rem', marginBottom: '16px', fontWeight: '600' }}>{ceo.title}</p>
            <p style={{ color: '#a0aec0', lineHeight: '1.7', fontSize: '0.95rem', marginBottom: '18px', textAlign: 'left' }}>{ceo.bio}</p>

            <a href={ceo.linkedin} target="_blank" rel="noopener noreferrer" style={{
              color: '#60a5fa', fontSize: '0.9rem', textDecoration: 'none', fontWeight: '600'
            }}>LinkedIn Profile &rarr;</a>
          </div>
        </div>

        {/* Connector line from CEO to reports */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '2px', height: '40px', backgroundColor: '#1a2744' }} />
        </div>

        {/* Horizontal connector bar */}
        <div style={{ display: 'flex', justifyContent: 'center', maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ width: '100%', height: '2px', backgroundColor: '#1a2744' }} />
        </div>

        {/* Vertical connectors down to each report card */}
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0',
          maxWidth: '900px', margin: '0 auto'
        }}>
          {reports.map((_, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '2px', height: '30px', backgroundColor: '#1a2744' }} />
            </div>
          ))}
        </div>

        {/* Report Cards */}
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px',
          maxWidth: '900px', margin: '0 auto'
        }}>
          {reports.map((person, i) => (
            <div key={i} style={{
              padding: '28px', backgroundColor: '#0a1628', borderRadius: '12px',
              border: '1px solid #1a2744', textAlign: 'center'
            }}>
              <div style={{
                width: '72px', height: '72px', borderRadius: '50%',
                backgroundColor: '#0f2847', display: 'flex', alignItems: 'center',
                justifyContent: 'center', margin: '0 auto 16px', fontSize: '1.3rem',
                color: '#60a5fa', fontWeight: '700',
                border: '2px solid #1a2744'
              }}>{person.name.split(' ').map(n => n[0]).join('')}</div>

              <h3 style={{ fontSize: '1.15rem', marginBottom: '6px' }}>{person.name}</h3>
              <p style={{ color: '#60a5fa', fontSize: '0.9rem', fontWeight: '600' }}>{person.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Join Us CTA */}
      <section style={{ padding: '60px 40px', backgroundColor: '#0a1628', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px' }}>Join Our Team</h2>
        <p style={{ color: '#a0aec0', maxWidth: '550px', margin: '0 auto 24px', lineHeight: '1.7' }}>
          We are always looking for talented engineers and leaders who are passionate about
          transforming enterprise networking.
        </p>
        <a href="mailto:careers@sarvanta.ai" style={{
          padding: '12px 28px', backgroundColor: '#2563eb', color: '#fff',
          borderRadius: '8px', textDecoration: 'none', fontWeight: '600', fontSize: '0.95rem'
        }}>Get in Touch</a>
      </section>
    </div>
  );
};

export default About;
